// We need jQuery
var $ = window.jQuery;

export default function () {
  var $form = $('#generatePaymentRequestModal #acf-form')
  var html

  if($('.ttl-cumulative').length) {
    html = '<ul id="populate-amounts"><li><a href="#" id="add-deposit">Add Deposit Amount</a></li><li><a href="#" id="add-total">Add Total Amount</a></li><li><a href="#" id="add-remaining">Add Remaining Balance</a></li></ul>'
  } else {
    html = '<ul id="populate-amounts"><li><a href="#" id="add-deposit">Add Deposit Amount</a></li><li><a href="#" id="add-total">Add Total Amount</a></li></ul>'
  }
  $('#generatePaymentRequestModal div[data-name="payment_amount"]').after(html)

  var total = $('.ttl-price').data('value')
  var deposit = $('.ttl-deposit').data('value')
  
  $('#populate-amounts #add-deposit').on('click', function() {
    $form.find('div[data-name="payment_amount"] input').val(deposit)
  })
  
  $('#populate-amounts #add-total').on('click', function() {
    $form.find('div[data-name="payment_amount"] input').val(total)
  })

  if($('.ttl-cumulative').length) {
    var remaining = total - $('.ttl-cumulative').data('value')
    $('#populate-amounts #add-remaining').on('click', function() {
      $form.find('div[data-name="payment_amount"] input').val(remaining.toFixed(2))
    })
  }  
}
